'use client'

import { type ReactNode, memo, useMemo } from 'react'

import { SessionProvider } from 'next-auth/react'

import { ToastProvider } from '@/components/common/toast/toast-provider'

import { BiometricInitProvider } from './biometric-init.provider'
import { BiometricProvider } from './biometric-provider'
import { QueryProvider } from './query.provider'
import { ReduxProvider } from './redux.provider'
import { ThemeProvider } from './theme.provider'

interface AppProviderProps {
  children: ReactNode
}

export const AppProvider = memo<AppProviderProps>(({ children }) => {
  const sessionProviderProps = useMemo(
    () => ({
      refetchInterval: 0,
      refetchOnWindowFocus: false,
    }),
    []
  )

  return (
    <SessionProvider {...sessionProviderProps}>
      <ReduxProvider>
        <QueryProvider>
          <ThemeProvider>
            <BiometricProvider autoConnect={true}>
              <BiometricInitProvider>
                <ToastProvider>{children}</ToastProvider>
              </BiometricInitProvider>
            </BiometricProvider>
          </ThemeProvider>
        </QueryProvider>
      </ReduxProvider>
    </SessionProvider>
  )
})

AppProvider.displayName = 'AppProvider'
